import { FormlyFieldConfig } from 'ng-formly';
export const widgetFields: Array<FormlyFieldConfig> = [
    {
        key: 'name',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: 'Name',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'description',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },
    {
        key: 'widgettype',
        type: 'select-component',
        templateOptions: {
            options: [{
                label: 'Table',
                value: 'table'
            }, {
                label: 'Chart',
                value: 'chart'
            }, {
                label: 'Metric',
                value: 'metric'
            }],
            label: 'Widget Type',
            required: true,
            default: 'table'
        }
    },
    {
        key: 'label',
        type: 'input-field',
        hideExpression: 'model.widgettype !== "metric"',
        templateOptions: {
            type: 'text',
            placeholder: 'Label',
            required: true,
            label: 'Label'
        }
    },
    {
        key: 'charttype',
        type: 'select-component',
        hideExpression: 'model.widgettype !== "chart"',
        templateOptions: {
            options: [{
                label: 'Pie Chart',
                value: 'piechart'
            }, {
                label: 'Line Chart',
                value: 'linechart'
            }, {
                label: 'Bar Chart',
                value: 'barchart'
            }, {
                label: 'Area Chart',
                value: 'area'
            },
            {
                label: 'Scatter Chart',
                value: 'scatter'
            }, {
                label: 'Radar Chart',
                value: 'radar'
            }, {
                label: 'Funnel Chart',
                value: 'funnel'
            }, {
                label: 'Graph Chart',
                value: 'graph'
            }, {
                label: 'Heatmap',
                value: 'heatmap'
            }, {
                label: 'Gauge',
                value: 'gauge'
            }, {
                label: 'Boxplot',
                value: 'boxplot'
            }, {
                label: 'Punch Card',
                value: 'punchcard'
            }, {
                label: 'Candle Stick',
                value: 'candlestick'
            }, {
                label: 'Parallel',
                value: 'parallel'
            }

            ],
            label: 'Chart Type',
            required: false,
            default: 'piechart'
        }
    }, {
        key: 'basefield',
        type: 'input-field',
        hideExpression: 'model.widgettype !== "chart"',
        templateOptions: {
            type: 'text',
            placeHolder: '',
            required: true,
            label: 'Base/X Field name'
        }
    }, {
        key: 'comparefields',
        type: 'multiInput',
        hideExpression: 'model.widgettype !== "chart"',
        templateOptions: {
            label: 'Compare/Y Fields name',
            required: false,
            inputOptions: {
                type: 'input-field',
                templateOptions: {
                    type: 'text'
                }
            }
        }
    }, {
        key: 'comparefields',
        type: 'multiInput',
        hideExpression: 'model.widgettype !== "chart"',
        templateOptions: {
            label: 'Compare/Y Fields name',
            required: false,
            inputOptions: {
                type: 'input-field',
                templateOptions: {
                    type: 'text'
                }
            }
        }
    }, {
        key: 'category',
        type: 'input-field',
        hideExpression: 'model.widgettype !== "chart"',
        templateOptions: {
            type: 'text',
            placeholder: 'Category',
            required: false,
            label: 'Category'
        }
    },
    {
        key: 'measure',
        type: 'input-field',
        hideExpression: 'model.widgettype !== "chart" && model.widgettype !== "metric"',
        templateOptions: {
            placeholder: 'Measure',
            required: false,
            label: 'Measure'
        }
    },
    {
        key: 'aggregation',
        type: 'select-component',
        hideExpression: 'model.widgettype !== "chart"',
        templateOptions: {
            options: [{
                label: 'Sum',
                value: 'sum'
            }, {
                label: 'Maximum',
                value: 'maximum'
            }, {
                label: 'Minimum',
                value: 'minimum'
            }, {
                label: 'Average',
                value: 'average'
            }, {
                label: 'Product',
                value: 'product'
            }],
            label: 'Aggregation',
            required: false,
            default: 'sum'
        }
    }
];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/widget.ts